export enum MEPUris {
    URI_MEP_CHAT = "mep://chat",
    URI_MEP_BIOMETRIC = "mep://biometric",
}
